// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The image tracker token.
 */
export const IImageTracker = new Token('@jupyterlab/imageviewer:IImageTracker', `A widget tracker for images.
  Use this if you want to be able to iterate over and interact with images
  viewed by the application.`);
//# sourceMappingURL=tokens.js.map